import React, { forwardRef } from 'react';

import CloseIcon from '../../../assets/images/close.svg';

import { clearButtonType } from '../types';

import * as S from '../styles';

const ClearButton = forwardRef<HTMLButtonElement, clearButtonType>(({ onClearHandler, isFocus }, ref) => (
    <S.ClearButton
        ref={ref}
        tabIndex={-1}
        data-locator="clearButton"
        $isInputFocus={isFocus}
        onClick={onClearHandler}
        type="button"
    >
       <CloseIcon />
    </S.ClearButton>
));

export default ClearButton;
